import * as v from "@badrap/valita";

export const $PaymentMethodId = v.string();

export type PaymentMethodId = v.Infer<typeof $PaymentMethodId>;

export const $PaymentMethod = v.object({
  id: $PaymentMethodId,
  label: v
    .string()
    .assert(
      (s) => s.length > 0 && s.length <= 100,
      "label must be 1-100 characters",
    ),
  allowChange: v.boolean(),
});

export type PaymentMethod = v.Infer<typeof $PaymentMethod>;

export const $PaymentMethodNew = v.object({
  label: v
    .string()
    .assert(
      (s) => s.length > 0 && s.length <= 100,
      "label must be 1-100 characters",
    ),
  allowChange: v.boolean(),
});

export type PaymentMethodNew = v.Infer<typeof $PaymentMethodNew>;

// Default payment method templates (for initial setup)
export const DEFAULT_PAYMENT_METHOD_TEMPLATES = [
  { label: "Carte Bancaire", allowChange: false },
  { label: "Monnaie", allowChange: true },
  { label: "Virement Bancaire", allowChange: true },
  { label: "Chèque", allowChange: true },
  { label: "Prélèvement Bancaire", allowChange: false },
] as const satisfies readonly PaymentMethodNew[];
